<template>
  <div class="t-articles-list">
    <router-link class="t-article-item"
                 v-for="item in articles.items"
                 :key="'article_' + item.id"
                 :to="{name: 'articles_view', params: {id: item.id, slug: item.slug}}">
      <p class="t-article-item__title">{{ item.title }}</p>
      <p class="t-article-item__date">{{ item.date }}</p>
    </router-link>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapGetters('articles', ['articles'])
        }
    }
</script>

<style lang="sass">
.t-articles-list
  display: flex
  align-items: center
  flex-wrap: wrap
  width: 100%

.t-article-item
  width: calc((100% - 40px) / 3)
  margin-right: 20px
  margin-bottom: 24px
  @extend %substrate
  @extend %substrate_hover
  padding: 20px
  height: 160px
  line-height: 1.2
  display: flex
  flex-direction: column
  &:nth-child(3n)
    margin-right: 0
  &__title
    font-weight: bold
    color: $blue
    display: -webkit-box
    -webkit-line-clamp: 4
    -webkit-box-orient: vertical
    overflow: hidden
  &__date
    margin-top: auto
    font-size: 14px
    color: $border

@media(max-width: 769px)
  .t-article-item
    width: 100%
    margin: 0 auto 24px
</style>


// WEBPACK FOOTER //
// src/vue_components/ArticlesList.vue